"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PDFAnnotation_1 = require("./PDFAnnotation");
Object.defineProperty(exports, "PDFAnnotation", { enumerable: true, get: function () { return PDFAnnotation_1.default; } });
var PDFWidgetAnnotation_1 = require("./PDFWidgetAnnotation");
Object.defineProperty(exports, "PDFWidgetAnnotation", { enumerable: true, get: function () { return PDFWidgetAnnotation_1.default; } });
var AppearanceCharacteristics_1 = require("./AppearanceCharacteristics");
Object.defineProperty(exports, "AppearanceCharacteristics", { enumerable: true, get: function () { return AppearanceCharacteristics_1.default; } });
tslib_1.__exportStar(require("./flags"), exports);
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/pdf-lib/cjs/core/annotation/index.js